import React from 'react';
import styled from 'styled-components';

import SignUpTandC from './SignUpTandC';
import { USTerms } from '../../../@types/USTerms';

const USAgreements = ({ confirmationMode, setUSTermsAndConditionsAllChecked }: USAgreementsProps) => {
	const defaultTermsState: USTerms = { termsAndConditions: false, notACasinoEmployee: false, isTwentyOne: false };
	const termsReducer = (tandcState, action) => {
		switch (action) {
			case 'termsAndConditions':
				return { ...tandcState, termsAndConditions: !tandcState.termsAndConditions };
			case 'notACasinoEmployee':
				return { ...tandcState, notACasinoEmployee: !tandcState.notACasinoEmployee };
			case 'isTwentyOne':
				return { ...tandcState, isTwentyOne: !tandcState.isTwentyOne };
			default:
				throw new Error(`${action} not found`);
		}
	};
	const [tandcstate, dispatch] = React.useReducer(termsReducer, defaultTermsState);

	React.useEffect(() => {
		if (tandcstate.termsAndConditions && tandcstate.notACasinoEmployee && tandcstate.isTwentyOne) {
			setUSTermsAndConditionsAllChecked(true);
		} else {
			setUSTermsAndConditionsAllChecked(false);
		}
	}, [
		setUSTermsAndConditionsAllChecked,
		tandcstate.isTwentyOne,
		tandcstate.notACasinoEmployee,
		tandcstate.termsAndConditions,
	]);

	return (
		<USAgreementsContainer>
			<SignUpTandC
				ts={tandcstate}
				setter={(action) => {
					dispatch(action);
				}}
				editable={!confirmationMode}
			/>
		</USAgreementsContainer>
	);
};

export default USAgreements;

interface USAgreementsProps {
	confirmationMode: boolean;
	setUSTermsAndConditionsAllChecked: (value: boolean) => void;
}

const USAgreementsContainer = styled.div(({ theme }) => ({
	color: theme.colors.darkR,
}));
